import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Form from "components/react-validation/components/form";
import Submit from "components/react-validation/components/submit";
import Dropzone from "react-dropzone";
import Linkify from "react-linkify";

import * as ProjectActionType from "Projects/constants";
import * as Vali from "helper/validator-helper";
import * as CommonActionType from "Common/constants";
import { v4 as uuidv4 } from "uuid";

import emptyImages from "assets/img/empty-images.svg";
import plusIcon from "assets/img/add-plus-icon.svg";
import exitIcon from "assets/img/exit.svg";

import { isEmpty } from "lodash";
import { Breadcrumb } from "components/breadcrumb/breadcrumb";

import queryString from "query-string";
import InventoryServices from "./services";

class EditCategoryItem extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.location,
    dispatch: PropTypes.func,

    projectId: PropTypes.string,
    inventoryId: PropTypes.number,
    inventoryDetails: PropTypes.object,
    removeImageAction: PropTypes.string,
    editCategoryProfileErrorMsg: PropTypes.string,
    goBack: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.inventoryServices = new InventoryServices(this.props.dispatch);

    this.state = {
      name: "",
      note: "",
      images: [],
      imageFiles: [],
      cancelUploadList: {},
      deleteUploadList: {},
      imagePreview: null,
      isViewing: true,
      errorExistedName: null,
    };
  }

  componentDidMount() {
    this.logUrlDetails();

    if (this.props.inventoryId) {
      this.inventoryServices.getInventoryById(this.props.inventoryId);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.logUrlDetails();
    }
  }

  logUrlDetails = () => {
    const { location, match } = this.props;
    const queryParams = queryString.parse(location.search);
    const projectId =
      match && match.params && match.params.projectId
        ? match.params.projectId
        : this.props.projectId;

    console.log("projectId from url:", projectId);
    console.log("lotTab from url:", queryParams.lotTab);
  };

  componentWillReceiveProps(nextProps) {
    const { removeImageAction } = this.props;
    const { removeImageAction: nextRemoveImageAction } = nextProps;

    if (
      removeImageAction ===
        ProjectActionType.GET_LIST_CATEGORY_PROFILE_IMAGES_ASYNC &&
      nextRemoveImageAction ===
        ProjectActionType.GET_LIST_CATEGORY_PROFILE_IMAGES_SUCCESS
    ) {
      this.setState({
        images: nextProps.inventoryDetails.images,
      });
    }

    if (
      removeImageAction ===
        ProjectActionType.GET_CATEGORY_PROFILE_DETAILS_ASYNC &&
      nextRemoveImageAction ===
        ProjectActionType.GET_CATEGORY_PROFILE_DETAILS_SUCCESS
    ) {
      this.setState({
        name: nextProps.inventoryDetails.name,
        note: nextProps.inventoryDetails.note,
        images: nextProps.inventoryDetails.images,
      });
    }

    if (
      this.props.editCategoryProfileErrorMsg !==
      nextProps.editCategoryProfileErrorMsg
    ) {
      this.setState({
        errorExistedName: nextProps.editCategoryProfileErrorMsg,
      });
    }
  }

  // services
  // end servies

  onSubmit = (e) => {
    e.preventDefault();
    const projectId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.projectId
        ? this.props.match.params.projectId
        : this.props.projectId;

    this.setState({
      errorExistedName: null,
    });

    this.props.dispatch({
      type: ProjectActionType.EDIT_CATEGORY_PROFILE_ASYNC,
      params: {
        id: this.props.inventoryDetails.id,
        projectId,
        name: this.state.name,
        note: this.state.note,
      },
      callback: () => {
        this.setState({ isViewing: true });
      },
    });
  };

  onDrop = (accepted, rejected) => {
    const { images } = this.props.inventoryDetails;
    if (rejected.length) {
      const errorMsg = "Only PNG, JPG, JPEG, BMP, TIFF supported.";
      this.setState({
        error: errorMsg,
      });
    } else if (accepted.length + images.length > 5) {
      const errorMsg = "Maximum 5 files uploaded.";
      this.setState({
        error: errorMsg,
      });
    } else {
      const currentFileState = [...this.state.imageFiles];

      this.setState(
        {
          files: currentFileState.concat(accepted),
          error: null,
        },
        () => this.handleFileUpload(accepted),
      );
    }
  };

  onClearError = () => {
    this.setState({ error: null });
  };

  renderError = () => {
    const { error } = this.state;

    if (error) {
      setTimeout(this.onClearError, 5000);
      return (
        <div
          className="alert alert-danger"
          style={{ width: "100%", margin: "0 15px 15px" }}
        >
          <p style={{ fontSize: 14 }}>{error}</p>
          <i
            className="fa fa-close"
            style={{
              position: "absolute",
              top: 14,
              right: 14,
              cursor: "pointer",
            }}
            onClick={this.onClearError}
          />
        </div>
      );
    }

    return null;
  };

  handleFileUpload = (files) => {
    const { projectId } = this.props;
    this.props.dispatch({
      type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
      params: {
        resourcePath: `projects/${projectId}/home-inventory/categories-image`,
      },
      callback: (awsCredential) => {
        this.awsCredential = awsCredential;

        files.map((file) => {
          file.uploadId = uuidv4();
          //handle image file
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
            paramsUpload: {
              projectId,
              file,
              config: awsCredential,
            },
            callback: (status, callbackData) => {
              callbackData.name = file.name;

              if (status === "pending") {
                const { cancelUploadList } = this.state;
                cancelUploadList[callbackData.uploadId] =
                  callbackData.cancelUpload;
                this.setState({
                  cancelUploadList,
                });
              } else if (status === "delete") {
                const { deleteUploadList } = this.state;
                deleteUploadList[callbackData.uploadId] =
                  callbackData.deleteFile;
                this.setState({
                  deleteUploadList,
                });
              } else if (status === true) {
                this.uploadImageUrl(callbackData, callbackData);
              }
            },
          });
        });
      },
    });
  };

  uploadImageUrl = (fileData) => {
    const { inventoryDetails } = this.props;
    this.props.dispatch({
      type: ProjectActionType.EDIT_CATEGORY_IMAGE_ASYNC,
      params: {
        data: {
          categoryId: inventoryDetails.id,
        },
        param: {
          fileName: fileData.name,
          key: fileData.data.Key,
          url: fileData.data.Location,
          thumbnailKey: fileData.data.Key,
          thumbnailUrl: fileData.data.Location,
        },
      },
      callback: () => {
        this.props.dispatch({
          type: ProjectActionType.GET_LIST_CATEGORY_PROFILE_IMAGES_ASYNC,
          params: { id: inventoryDetails.id },
        });
      },
    });
  };

  onClickCancelButton = () => {
    this.setState({ isViewing: true });
  };

  onClickEditButton = () => {
    this.setState({ isViewing: false });
  };

  onTogglePreviewImages = (url) => {
    this.setState({
      imagePreview: url,
    });
  };

  onRemoveImage = (id) => {
    const { dispatch, inventoryDetails } = this.props;
    dispatch({
      type: ProjectActionType.DELETE_CATEGORY_IMAGE_ASYNC,
      params: {
        id: id,
      },
      callback: () => {
        this.props.dispatch({
          type: ProjectActionType.GET_LIST_CATEGORY_PROFILE_IMAGES_ASYNC,
          params: { id: inventoryDetails.id },
        });
      },
    });
  };

  renderCategoryValue = (value) => {
    if (value) {
      return (
        <Linkify>
          <strong style={{ wordBreak: "break-word" }}>{value}</strong>
        </Linkify>
      );
    }
    return <span style={{ opacity: ".5" }}>(Not specified)</span>;
  };

  onCustomAction = () => {
    this.onBack();
  };

  onChangeText = (type) => (e) => {
    this.setState({
      [type]: e.target.value,
      ...(type === "name" ? { errorExistedName: null } : {}),
    });
  };

  renderErrorMsg = () => {
    const errorExistedName =
      this.state.errorExistedName || this.props.editCategoryProfileErrorMsg;

    if (errorExistedName) {
      return <span className="cls-danger help-block">{errorExistedName}</span>;
    }

    return null;
  };

  onViewItemsOfCategory = () => {
    const { location, history } = this.props;
    const queryParams = queryString.parse(location.search);

    history.push({
      pathname: location.pathname,
      search: queryString.stringify({
        ...queryParams,
        tab: "inventoryItem",
        inventoryId: this.props.inventoryDetails.id,
      }),
    });
  };

  render() {
    const { inventoryDetails } = this.props;
    let { note, name, images, imagePreview, isViewing } = this.state;

    const acceptFileType =
      "image/jpeg, image/png , image/bmp, image/jpg, image/tiff";

    const breadcrumbs = [
      { title: "Inventory", url: "/", onCustomAction: this.props.goBack },
      { title: `${inventoryDetails && inventoryDetails.name}`, url: "" },
    ];

    return (
      <React.Fragment>
        <div>
          <h4
            style={{
              height: 30,
              marginTop: -15,
              margin: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {inventoryDetails && inventoryDetails.name}
          </h4>
          <Form
            ref={(c) => {
              this.form = c;
            }}
            onSubmit={this.onSubmit}
          >
            <div className="breadcumb-category">
              <Breadcrumb breadcrumbs={breadcrumbs} />
            </div>
            <div
              className={
                isViewing
                  ? "add-new-category-item row"
                  : "edit-new-category-item row"
              }
            >
              <div className="col-md-6 col-sm-6 col-xs-12">
                <div className={isViewing ? "view-details" : "form-group"}>
                  <div
                    className={
                      isViewing
                        ? "row col-sm-12 margin-bottom-20"
                        : "row col-sm-12"
                    }
                  >
                    <label
                      className={
                        isViewing
                          ? "col-sm-3 col-xs-12 font-normal control-label"
                          : ""
                      }
                    >
                      Name{" "}
                      {!isViewing && <strong className="text-danger">*</strong>}
                    </label>
                    {!isViewing ? (
                      <React.Fragment>
                        <input
                          name="name"
                          ref="name"
                          placeholder="Name"
                          className="form-control"
                          autoFocus
                          value={name}
                          max="254"
                          maxLength="254"
                          onChange={this.onChangeText("name")}
                          validations={[Vali.required, Vali.maxlength]}
                        />
                        {this.renderErrorMsg()}
                      </React.Fragment>
                    ) : (
                      <div className="col-sm-9 control-label name form-text-label">
                        {this.renderCategoryValue(name ? name : null)}
                      </div>
                    )}
                  </div>
                </div>
                <div className={isViewing ? "view-details" : "form-group"}>
                  <div
                    style={isViewing ? {} : { marginTop: 15 }}
                    className={
                      isViewing
                        ? "row col-sm-12 margin-bottom-20"
                        : "row col-sm-12"
                    }
                  >
                    <label
                      className={
                        isViewing
                          ? "col-sm-3 col-xs-12 font-normal control-label"
                          : ""
                      }
                    >
                      Notes
                    </label>
                    {!isViewing ? (
                      <textarea
                        style={{ minHeight: 300 }}
                        name="note"
                        ref="note"
                        className="form-control"
                        value={note}
                        max="1000"
                        maxLength="1000"
                        onChange={this.onChangeText("note")}
                        validations={[Vali.maxlength]}
                      />
                    ) : (
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-all",
                        }}
                        className="col-sm-9 control-label note form-text-label"
                      >
                        {this.renderCategoryValue(note ? note : null)}
                      </div>
                    )}
                  </div>
                </div>
                {isViewing && (
                  <div style={{ margin: "10% 0 10%" }} className="row">
                    <div className="col-sm-6 col-xs-12">
                      <button
                        onClick={this.onClickEditButton}
                        className="btn btn-primary btn-siteone"
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                )}
                {isViewing && (
                  <div style={{ marginLeft: "12px" }}>
                    <div
                      style={{ display: "inline-block", cursor: "pointer" }}
                      onClick={this.onViewItemsOfCategory}
                    >
                      <img src={exitIcon} width={24} height={24} />
                      <span> View all associated items</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="image-category col-md-6 col-sm-6 col-xs-12">
                {this.renderError()}
                <div className="preview-category-image">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12 col-xs-12">
                        {!imagePreview && (
                          <img
                            className="empty-category-image"
                            src={
                              images && images[0] ? images[0].url : emptyImages
                            }
                            alt="no-files"
                          />
                        )}
                        {imagePreview && (
                          <img
                            className="empty-category-image"
                            src={
                              imagePreview && !isEmpty(images)
                                ? imagePreview
                                : emptyImages
                            }
                            alt="no-files"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="list-thumbnail-image-after-upload">
                    {/* <div className='container-fluid'> */}
                    <div className="row">
                      {/* map img*/}

                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                        className="col-md-12 col-xs-6"
                      >
                        <div className="container-fluid">
                          {!isEmpty(images) &&
                            images.map((el, index) => {
                              return (
                                <div
                                  key={index}
                                  className="image-file-after-upload col-md-2 col-xs-2 col-lg-2"
                                >
                                  <span
                                    onClick={() => this.onRemoveImage(el.id)}
                                    className="close"
                                  >
                                    &times;
                                  </span>
                                  <img
                                    className="category-img-item"
                                    onClick={() =>
                                      this.onTogglePreviewImages(el.url)
                                    }
                                    src={el.url}
                                  />
                                </div>
                              );
                            })}
                          {images && images.length < 5 && (
                            <div className="image-file-after-upload col-md-2 col-xs-2 col-lg-2">
                              <Dropzone
                                disableClick
                                accept={acceptFileType}
                                ref={(node) => {
                                  this.dropzoneRef = node;
                                }}
                                className="category-images-dropzone"
                                onDrop={this.onDrop}
                              >
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.dropzoneRef.open();
                                  }}
                                  className="add-image-category btn btn-primary btn-siteone-default"
                                >
                                  <img src={plusIcon} />
                                </button>
                              </Dropzone>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="thumbnail-image-add-success" />
              </div>
            </div>
            {!isViewing && (
              <div className="row">
                <div className="col-md-12 col-xs-12">
                  <span
                    className="btn btn-siteone-default"
                    onClick={this.onClickCancelButton}
                  >
                    Cancel
                  </span>
                  <Submit className="btn btn-primary btn-siteone">Save</Submit>
                </div>
              </div>
            )}
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    inventoryDetails: state.ProjectStore.categoryProfile,
    removeImageAction: state.ProjectStore.removeImageAction,
    editCategoryProfileErrorMsg: state.ProjectStore.editCategoryProfileErrorMsg,
  };
};

export default withRouter(connect(mapStateToProps)(EditCategoryItem));



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/inventory-edit.js